import React, { useEffect } from 'react';
import { CallerId } from '@features/numbers/components/Numbers/CallerId.tsx';
import { useBreadcrumbStore } from '@ui/Layout/store/useBreadcrumbStore.ts';
import NumbersSection from '@features/numbers/components/Numbers/NumbersSection.tsx';
import { getCurrentUser } from '@features/auth';

export function NumbersPageSettings (): React.JSX.Element {
  const setItems = useBreadcrumbStore((s) => s.setItems);

  const isSuperAdmin = getCurrentUser()?.isSuperAdmin ?? false;
  const isAdmin = getCurrentUser()?.isAdmin ?? false;

  useEffect(() => {
    setItems([
      { labelKey: 'breadcrumb.home', href: '/workspace/sessions/new' },
      { labelKey: 'breadcrumb.numbers', href: '/workspace/numbers' },
    ]);
  }, [setItems]);

  return (
    <>
      <div className="space-y-6">
        <div className="items-start justify-between">
          <CallerId />
        </div>
      </div>
      
      {(isSuperAdmin || isAdmin) && (
        <div className="space-y-6 mt-5">
          <div className="items-start justify-between">
            <NumbersSection isSuperAdmin={isSuperAdmin} />
          </div>
        </div>
      )}
    </>
  );
}